import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props as SvgProps } from '../../../shared/assets/SvgProps';

const SearchResult: React.FC<SvgProps> = ({ color = '#707070' }) => (
  <Svg width="13" height="11" viewBox="0 0 13 11" fill="none">
    <Path
      d="M6.95833 0.624919L11.625 5.29159L6.95833 9.95825"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M0.625 5.2915L11.625 5.2915"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default SearchResult;
